<template>
  <v-card
      :loading="loading"
      class="my-2"
      :class="transparent ? 'transparent' : ''"
      width="372"
  >
    <template slot="progress">
      <v-progress-linear
          color="indigo darken-3"
          height="10"
          indeterminate
      ></v-progress-linear>
    </template>

    <v-card-title>
      {{storeName}}
      <v-icon v-if="verified" size="18px" class="ml-1" color="primary">mdi-check-decagram</v-icon>
    </v-card-title>

    <v-card-text class="mb-0 pb-0">
      <div class="mb-4">
        <v-icon class="mr-2" size="22">mdi-shield-key</v-icon>
        <small>{{storeAccount}}</small>
      </div>
      <div style="height: 70px; overflow-y: auto">{{storeSummary}}</div>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <v-card-actions class="d-flex justify-end">
      <router-link :to="{
        name: 'store',
        query: {storeAccount}
      }" class="router-link"
      >
        <v-btn
            color="indigo darken-3"
            text
        >
          Visit
        </v-btn>
      </router-link>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "StoreCard",
  props: {
    storeName: String,
    storeAccount: String,
    storeSummary: String,
    transparent: Boolean,
    verified: Boolean
  },
  data: () => ({
    loading: false,
    selection: 1,
  }),
}
</script>

<style scoped>

</style>